import React from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import s from './Button.scss';

const Button = ({ text, type, location, href, disabled = false, clickEventHandler = () => {}, mouseEnterEventHandler, mouseLeaveEventHandler }) => {
	if (type === 'a') {
		const attrs = {};
		if (href) attrs.href = href;
		return <a className={s.button} {...attrs} onClick={(e) => clickEventHandler(e)}>{ text }</a>; // eslint-disable-line
	}
	if (type === 'link') {
		return <Link className={s.button} to={location}>{ text }</Link>;
	}
	// eslint-disable-next-line react/button-has-type
	return <button className={s.button} disabled={disabled} type={type} onClick={clickEventHandler} onMouseEnter={mouseEnterEventHandler} onMouseLeave={mouseLeaveEventHandler}>{ text }</button>;
};

export default hot(module)(Button);
